import { render } from "./collegeWards.vue?vue&type=template&id=c88afc9e"
import script from "./collegeWards.vue?vue&type=script&lang=js"
export * from "./collegeWards.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__